const appRoutes = {
  HOMEPAGE: "/",
  LOGIN: "/login",
  LOYALTY: "/my-account/loyalty",
  MYACCOUNT: "/my-account",
  MYACCOUNT_PURCHASES: "/my-account/purchases",
  MYACCOUNT_PURCHASE_DETAIL: "/order-detail",
  MYACCOUNT_WISHLIST: "/my-account/wishlist",
  MYACCOUNT_SETTINGS: "/my-account/settings",
  POWERREVIEWS_WRITE_A_REVIEW: "/write-a-review",
  PASSWORD_RESET_REQUEST: "/password-reset-request",
  SIGN_UP: "/sign-up",
  FAQ_HELP: "/faq-help",
  CUSTOMER_HELP_CENTER: "/customer-help-center",
  REQUEST_RETURN: "/request-return",
  CART: "/cart",
  CHECKOUT: "/checkout",
  THANKYOU: "thankyou",
  SEARCH: "/search/",
  CATEGORY: "/c/",
  TRACK_YOUR_ORDER: "/track-your-order/",
  // These are not an actual root, but editorials
  COOKIE_POLICY: "help/cookie-policy",
  PRIVACY_POLICY: "help/privacy-policy",
  STORE_LOCATOR: "https://kiko-stores.kikocosmetics.com",
  ACCESSIBILITY_STATEMENT: "secure-purchases/accessibility-statement",
};
export default appRoutes;
